import React from 'react';
import './AuthHeader.css';
import logo from '../../assets/images/logo.png'
import { useNavigate } from "react-router-dom";
import { useTranslation } from 'react-i18next';
import LanguageDropdown from '../../@core/layouts/components/shared-components/LanguageDropdown';

/**
 * AuthHeader Component
 * 
 * Header navigation for authentication pages
 * Contains logo, tagline, navigation links, and action buttons
 * 
 * @component
 */
const AuthHeader = () => {
  const { t } = useTranslation('auth');
  const navigate = useNavigate();
  
  // Simple settings for LanguageDropdown
  const [settings, setSettings] = React.useState({
    layout: 'horizontal',
    direction: 'ltr'
  });
  
  const saveSettings = (newSettings) => {
    setSettings(newSettings);
  };
  
  const navLinks = [
    { label: t('aboutUs'), href: '#about' },
    { label: t('pricing'), href: '#pricing' },
    // { label: 'demo', href: '#demo' },
    // { label: 'blog', href: '#blog' },
    { label: t('printMaterial'), href: '/business/printingmaterial' }
  ];

  // Dummy handler for navigation clicks (no actual routing)
  const handleNavClick = (e, href) => {
    e.preventDefault();
    navigate(href);
    console.log('Navigate to:', href);
  };

  // Dummy handler for login button
  const handleLogin = () => {
    console.log('Login clicked');
    navigate('/business/login');
  };

  return (
    <header className="auth-header">
      {/* Left section - Logo and tagline */}
      <div className="auth-header__left">
        <div className="auth-header__logo">
          <div className="auth-header__logo-icon">
            <img src={logo} />
            <div className="auth-header__tagline">
              {t('tagline')}
            </div>
          </div>
        </div>
      </div>

      {/* Center section - Navigation links */}
      {/* <nav className="auth-header__nav">
        {navLinks.map((link) => (
          <a
            key={link.label}
            href={link.href}
            className="auth-header__nav-link"
            onClick={(e) => handleNavClick(e, link.href)}
          >
            {link.label}
          </a>
        ))}
      </nav> */}

      {/* Right section - Action buttons */}
      <div className="auth-header__actions">
        <nav className="auth-header__nav">
          {navLinks.map((link) => (
            <a
              key={link.label}
              href={link.href}
              className="auth-header__nav-link"
              onClick={(e) => handleNavClick(e, link.href)}
            >
              {link.label}
            </a>
          ))}
        </nav>
        
        {/* Language Dropdown */}
        <div className="language-dropdown">
          <LanguageDropdown 
            settings={settings} 
            saveSettings={saveSettings} 
          />
        </div>
        
        <button
          className="auth-header__btn auth-header__btn--login"
          onClick={handleLogin}
        >
          {t('login')}
        </button>
      </div>
    </header>
  );
};

export default AuthHeader;



